// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loadingComponent_loaderContainer__YTAJU","loader":"loadingComponent_loader__1+JeV","loaderAnimation":"loadingComponent_loaderAnimation__zoOnb"};